// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2F8K0","name":"ConsentHeader_name__1NwBF","birthday":"ConsentHeader_birthday__2BdMA","skeleton":"ConsentHeader_skeleton__3rKal"};